<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 22 22"
    :height="height"
    :width="width"
  >
    <g transform="translate(1, 1)">
      <g fill-rule="evenodd" fill="none" stroke-width="1" stroke="none" id="Symbols">
        <g
          :fill="iconColor ? iconColor : '#256AB3'"
          transform="translate(-2.000000, -2.000000)"
          id="icon/other/social/facebook"
        >
          <path
            id="facebook"
            d="M12,2 C17.5228516,2 22,6.49459131 22,12.0389598 C22,17.1583195 18.1828516,21.3824471 13.25,22 L13.25,14.5486997 L16.6875,14.5486997 L17,12.0389598 L13.25,12.0389598 L13.25,10.7840898 C13.25,10.0910487 13.8096094,9.52921984 14.5,9.52921984 L17,9.52921984 L17,7.0194799 L14.5,7.0194799 C12.4289062,7.0194799 10.75,8.70492713 10.75,10.7840898 L10.75,12.0389598 L8.875,12.0389598 L8.875,14.5486997 L10.75,14.5486997 L10.75,19.5093576 L10.75,21.7616531 L10.75,22 C5.81714844,21.3824079 2,17.1583195 2,12.0389598 C2,6.49459131 6.47714844,2 12,2 Z"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "facebookIcon",
  props: ["height", "width", "iconColor"],
  methods : {
    
  }
};

</script>

<style scoped>
</style>
